import { Component, computed, input } from "@angular/core";

import { PercentageValuePipe } from "../../../../core/pipes";
import { Constants } from "../../../constants/constants";

@Component({
  selector: "adaa-progress-indicator",
  templateUrl: "./progress-indicator.html",
  styleUrl: "./progress-indicator.scss",
  imports: [PercentageValuePipe],
})
export class ProgressIndicatorComponent {
  value = input<number | undefined>();
  color = input<number | undefined>();
  label = input<string | undefined>();
  height = input<number>(6);
  fontSize = input<string>("0.75rem");
  showValue = input<boolean>(true);
  background = input<string>("#e6ebf2");

  colorString = computed(() => Constants.COLOR_CODES[this.color() ?? Constants.CONSTANT_COLORS.EVALUATION_GRAY]);
  // The label sits above the bar now, so a trailing ": " left over from the old inline layout is dropped
  displayLabel = computed(() => this.label()?.replace(/[\s:]+$/, "") ?? "");
  width = computed(() => Math.min(Math.max(this.value() ?? 0, 0), 100));
}
